// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import CaretDown from "@synd/XDL/Icons/AngleDown";
import { xBaseTheme } from "@synd/XDL/types";
import { color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            width: 11,
            height: 13,
            color: "common.ui7",
            src: CaretDown,
            css: css`
                &&& {
                    background-color: transparent;
                    padding: 0;
                    width: auto;
                    top: 2px;
                    right: 8px;
                }
            `,
        },
        css: css`
            cursor: pointer;
            &&&& {
                padding-right: 24px;
                ${xScreen("lte", "sm")} {
                    text-align: left;
                }
            }
            &:hover ~ ${IconWrapper} {
                color: ${color("common.ui9")};
            }
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
                padding: 0;
            }
        `,
    },
} as xBaseTheme["select"];
